import { Product } from '@axo/shared/data-access/types';
import { addTranslationBundle, TranslationProvider } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { Card } from '@axo/ui-core/components/Card';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Heading } from '@axo/ui-core/components/typography';
import * as Sentry from '@sentry/browser';
import { AxoFormContextProvider } from '../../../../context/AxoForm/AxoForm';
import {
  PreFormComponentProps,
  PreFormViewProps,
} from '../../../FormProps.types';
import { SwedenFormData } from '../FormData.se.types';
import { mutators, se, steps } from '../config';
import styles from '../loan.module.scss';
import { Step1 } from '../steps/Step1';

addTranslationBundle({ LoanApplication: { se } });

const PreFormView = ({
  heading,
  options,
  hasCard = false,
}: PreFormViewProps) => {
  Sentry.setTag('axo-form', 'v2');
  Sentry.setTag('country', 'se');
  Sentry.setTag('product', 'loan');

  const Content = (
    <>
      {heading && <Heading size="m">{heading}</Heading>}
      <Step1 isPre={true} options={options} />
    </>
  );

  return hasCard ? (
    <Card variant="pre-form">{Content}</Card>
  ) : (
    <Stack gap="m">{Content}</Stack>
  );
};

export function Pre({
  baseUrl,
  redirectUrl,
  onCompleted,
  ...viewProps
}: PreFormComponentProps) {
  return (
    <TranslationProvider language="se" ns="LoanApplication">
      <AxoFormContextProvider<SwedenFormData>
        isPre
        product={Product.UnsecuredLoan}
        marketCountry={MarketCountryCode.Sweden}
        mutators={mutators}
        baseUrl={baseUrl}
        redirectUrl={redirectUrl}
        steps={[steps[0]]}
        onCompleted={onCompleted}
      >
        <PreFormView {...viewProps} />
      </AxoFormContextProvider>
    </TranslationProvider>
  );
}

export default Pre;
